import { OlRateIdInput } from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { MobileNumberForFrenchLeaderInput } from '../../../lib/types/models/ol/mobile-number-for-french-leader/mobile-number-for-french-leader-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateMobileNumberForFrenchLeader = async (
  data: Partial<MobileNumberForFrenchLeaderInput> & OlRateIdInput
) => {
  const { id, olId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.ols.updateMobileNumberForFrenchLeader.url, { id, olId }))
    .patch<MobileNumberForFrenchLeaderInput, Partial<MobileNumberForFrenchLeaderInput>>(rest)
}
